module.exports = "<comment-form class=\"comment-form\"\n              item=\"$ctrl.task\"\n              on-comment-submit=\"$ctrl.onCommentSubmit(comment)\">\n</comment-form>\n\n<comment-card class=\"comment-card\"\n              comment=\"comment\"\n              ng-repeat=\"comment in $ctrl.task.comments track by comment.id\">\n</comment-card>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/screens/task-detail-msgs/task-detail-msgs.html
// module id = 357
// module chunks = 0